import { SITE } from '@/app/constants';

const MEDIA_BASE_URL =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset'
    : 'https://image01.cf.vidu.studio/vidu/media-asset';

export const LANDING_ASSETS = {
  collage: `${MEDIA_BASE_URL}/collage-fb66b54f.webp`,
  creatorArtist: `${MEDIA_BASE_URL}/creator-artist-6d63a8c4.webp`,
  creatorRising: `${MEDIA_BASE_URL}/creator-rising-e2a4fa32.webp`,
  heroBg: `${MEDIA_BASE_URL}/hero-bg-33c38341.webp`,
  step1: `${MEDIA_BASE_URL}/step-1-2909323c.webp`,
  step2: `${MEDIA_BASE_URL}/step-2-5de059f4.webp`,
  step3: `${MEDIA_BASE_URL}/step-3-9f9c09b4.webp`,
} as const;
